import api from "./api";

const campusService = {
  dashboard: () => api.get("/campus/dashboard").then((r) => r.data),
};

export default campusService;
